var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"dropdownTarget",staticClass:"dropdown-target",class:_vm.bem('dropdown-target', { fullWidth: _vm.fullWidth })},[_vm._t("default",null,{"show":_vm.show,"hide":_vm.dropdown.hide,"visible":_vm.visible})],2)}
var staticRenderFns = []

export { render, staticRenderFns }